import type { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/** "padrao" = Home; "tv" = slide do modo TV (tema escuro, fontes grandes). */
export type Variante = "padrao" | "tv";

const COLUNAS: Record<number, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-4",
  5: "sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5",
};

const COLUNAS_TV: Record<number, string> = {
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
};

export function GradeKpis({ variante, colunas, children }: { variante: Variante; colunas: number; children: ReactNode }) {
  const tv = variante === "tv";
  return <dl className={cn("grid", tv ? cn("gap-6", COLUNAS_TV[colunas]) : cn("gap-4", COLUNAS[colunas]))}>{children}</dl>;
}

interface KpiProps {
  rotulo: string;
  valor: string;
  isLoading: boolean;
  variante: Variante;
  /** Cor semântica (ver CORES): o número na TV, a faixa do card na Home. */
  cor?: string;
  /** Linha de apoio (ex. "+12 no mês"). */
  detalhe?: string;
}

// dt antes de dd no DOM (semântica), mas o número aparece primeiro: `order`.
export function Kpi({ rotulo, valor, isLoading, variante, cor, detalhe }: KpiProps) {
  if (variante === "tv") {
    return (
      <div className="flex flex-col rounded-xl border border-white/10 bg-white/5 px-6 py-5">
        <dt className="order-2 text-xl text-slate-400">{rotulo}</dt>
        <dd className="order-1 text-5xl font-semibold tabular-nums text-white" style={cor ? { color: cor } : undefined}>
          {isLoading ? <Skeleton className="h-12 w-32 bg-white/10" /> : valor}
        </dd>
        {detalhe && <dd className="order-3 mt-1 text-lg text-slate-500">{detalhe}</dd>}
      </div>
    );
  }

  // Na Home a cor vai numa faixa: amarelo em texto sobre branco não teria contraste.
  return (
    <div
      className="flex flex-col rounded-xl border border-border border-t-4 bg-card px-5 py-4 shadow-card"
      style={cor ? { borderTopColor: cor } : undefined}
    >
      <dt className="order-2 text-sm text-muted-foreground">{rotulo}</dt>
      <dd className="order-1 text-3xl font-semibold tabular-nums text-foreground">
        {isLoading ? <Skeleton className="h-9 w-24" /> : valor}
      </dd>
      {detalhe && <dd className="order-3 mt-0.5 text-xs text-muted-foreground">{detalhe}</dd>}
    </div>
  );
}
